var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "directions_black_24dp 4",
    clipPath: "url(#clip0_2682_11420)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9533 7.05995L8.94659 1.05329C8.44659 0.553285 7.56659 0.546619 7.05992 1.05329L1.05992 7.05329C0.539922 7.57329 0.539922 8.41328 1.05992 8.93328L7.05992 14.9333C7.31992 15.1933 7.65992 15.32 7.99992 15.32C8.33992 15.32 8.67992 15.1933 8.93992 14.9333L14.9333 8.93995C15.4599 8.43329 15.4666 7.59329 14.9533 7.05995ZM8.00659 13.9933L2.00659 7.99329L8.00659 1.99329L14.0066 7.99329L8.00659 13.9933ZM5.33325 7.33329V9.99995H6.66659V7.99995H9.33325V9.66662L11.6666 7.33329L9.33325 4.99995V6.66662H5.99992C5.63326 6.66662 5.33325 6.96662 5.33325 7.33329Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2682_11420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.2697c02926781e6c3163b6c99dcd2315.svg";
export { ForwardRef as ReactComponent };